export default "__VITE_ASSET__CjRom4OO__"